/**
 * Segment for `/r/:segment` URLs: prefer `res2.id`, then `res2.alias`.
 * @param {{ id?: unknown; alias?: unknown } | null | undefined} res2
 * @returns {string}
 */
export function restaurantPathSegment(res2) {
  if (res2 == null) return "";
  const id = res2.id;
  if (id != null && id !== "") return String(id);
  const alias = res2.alias;
  if (alias != null && alias !== "") return String(alias);
  return "";
}
